const FREE_SHIPPING_THRESHOLD_TEST = {
    id: 'freeShippingThreshold',
    processedKey: 'monetateAbTestFreeShippingThresholdProcessed',
    sessionKey: 'freeShippingThreshold',
    // LeanConvert contract: window.__KS_EXPERIMENTS__.freeShipping
    experimentKey: 'freeShipping',
    endpoint: 'https://engine.monetate.net/api/engine/v1/decide/kendrascott',
    buildRequestBody: ({requestId, monetateId, customerId, contextEvents = []}) => ({
        channel: 'a-b2c6af1a/p/kendrascott.com',
        ...(monetateId ? {monetateId} : {}),
        ...(customerId ? {customerId} : {}),
        events: [
            {
                eventType: 'monetate:decision:DecisionRequest',
                requestId,
                includeReporting: false
            },
            ...contextEvents
        ]
    }),
    getSessionValue: (response) => {
        const freeShippingPrice = response?.data?.responses?.[0]?.actions?.find(
            (action) => action?.actionType === 'monetate:action:OmnichannelJson'
        )?.json?.featureFlag?.freeShippingPrice

        if (freeShippingPrice === true || freeShippingPrice === 'true') {
            return 'A'
        }

        if (freeShippingPrice === false || freeShippingPrice === 'false') {
            return 'B'
        }

        return null
    }
}

// Each test definition owns its Monetate endpoint, payload builder, and response mapping.
const MONETATE_AB_TESTS = [FREE_SHIPPING_THRESHOLD_TEST]

export default MONETATE_AB_TESTS
